import {useLocation, useNavigate, useParams} from "react-router-dom";
import {Button} from "react-bootstrap";
import {DetailsView} from "../../modules/Clothes/components/DetailsView";
import s from './detailsViewScreen.module.css';


export default function DetailsViewScreen() {
    const navigate = useNavigate();
    const location = useLocation()
    const { clothId} = useParams();
    
    const isNewCloth = location.pathname === "/create" ? true : false;

    return (
        <>
            <div>
                <Button variant="primary" onClick={() => navigate(-1)} hidden={true}>
                    {'Назад'}
                </Button>
                <DetailsView
                    clothId={clothId || '-1'}
                    isNew={isNewCloth}
                />
            </div>
        </>
    )
}